export function getPlaceTitle(placeVal, provinces = []) {
  if (!placeVal) return "";
  if (Array.isArray(provinces) && provinces.length > 0) {
    const found = provinces.find(
      (p) => String(p.ID) === String(placeVal) || String(p.id) === String(placeVal)
    );
    if (found && found.title) {
      return found.title;
    }
  }
  return placeVal;
}
